<template>
  <div class="store-locator-faq">
    <SectionLoader v-if="isLoading" status :opacity="1" />
    <StoreLocatorFaqTitle
      :title="$t('message.storeLocator.faq.addFaqToFacilities')"
      :quantity="commonFaq.length"
      @open-add-dialog="showAddDialog = true"
    />
    <InfoBox :text="$t('message.storeLocator.faq.orderInfoText')" />
    <StoreLocatorFaqList
      v-if="commonFaq.length"
      :title="$t('message.storeLocator.faq.allFacilities')"
      :is-expandable="false"
    >
      <StoreLocatorFaqListItem
        v-for="(item, index) in commonFaq"
        :key="item.id"
        :question="item.question"
        :answer="item.answer"
        :date="item.created_at"
        :is-last="index === commonFaq.length - 1"
        :is-first="index === 0"
        @move="handleMove(item.id, $event)"
        @update="handleUpdate(item.id, $event)"
        @delete="handleDelete(item.id)"
      />
    </StoreLocatorFaqList>
    <StoreLocatorFaqEmptyState v-else />

    <StoreLocatorFaqManageDialog
      v-if="showAddDialog"
      @close="showAddDialog = false"
      @create="handleCreate"
    />
  </div>
</template>

<script>
import StoreLocatorFaqEmptyState from "@/components/StoreLocatorFaq/StoreLocatorFaqEmptyState.vue";
import StoreLocatorFaqTitle from "@/components/StoreLocatorFaq/StoreLocatorFaqTitle.vue";
import StoreLocatorFaqListItem from "@/components/StoreLocatorFaq/StoreLocatorFaqListItem.vue";
import StoreLocatorFaqList from "@/components/StoreLocatorFaq/StoreLocatorFaqList.vue";
import InfoBox from "@/components/ui/InfoBox.vue";
import SectionLoader from "@/components/Loader/SectionLoader.vue";
import storeLocatorService from "@/services/storeLocator";
import serviceHandler from "@/helpers/handlers/service";
import { storeLocatorFaqMixin } from "@/helpers/mixins/store-locator-faq";

export default {
  name: "StoreLocatorFaq",
  mixins: [storeLocatorFaqMixin],
  components: {
    StoreLocatorFaqEmptyState,
    StoreLocatorFaqTitle,
    StoreLocatorFaqListItem,
    StoreLocatorFaqList,
    InfoBox,
    SectionLoader,
    StoreLocatorFaqManageDialog: () =>
      import("@/components/StoreLocatorFaq/StoreLocatorFaqManageDialog.vue")
  },
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showAddDialog: false,
      editData: null,
      isLoading: true
    };
  },
  async created() {
    await this.initializeCommonFaq();
  },
  methods: {
    async handleMove(id, payload) {
      await this.withLoadingState(async () => {
        await serviceHandler(storeLocatorService.patchDefaultFaq(id, payload));
        await this.getCommonFaq();
      });
    },
    async handleUpdate(id, payload) {
      await this.withLoadingState(async () => {
        await serviceHandler(storeLocatorService.patchDefaultFaq(id, payload));
        await this.getCommonFaq();
      });
    },
    async handleCreate(data) {
      this.showAddDialog = false;
      await this.withLoadingState(async () => {
        await serviceHandler(
          storeLocatorService.postDefaultFaq({
            ...data,
            store_locator_settings: this.config.key
          })
        );
        await this.getCommonFaq();
      });
    },
    async handleDelete(id) {
      await this.withLoadingState(async () => {
        await serviceHandler(storeLocatorService.deleteDefaultFaq(id));
        await this.getCommonFaq();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.store-locator-faq {
  padding: $spacing * 3;
  display: flex;
  flex-direction: column;
  gap: $spacing * 2;

  &__actions {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
